import ApiService from '../_helper/api.service';
import LandingApiResources from '../../constants/api/resources/landing';
import { GetRoomTypesInterface } from '@/types/api/landing/roomTypesInterface';

const HotelService = {
  showCancellationPolicy(hid: string) {
    const config = { params: { hotel_hid: hid } };
    return ApiService.get(LandingApiResources.cancellationPolicy, config);
  },

  getLegalInfo(hid: string) {
    const config = { params: { hotel_hid: hid } };
    return ApiService.get(LandingApiResources.gmoLegalInfo, config);
  },

  getRoomTypeInfo(data: GetRoomTypesInterface) {
    return ApiService.get(LandingApiResources.roomTypeInfo, { params: data });
  },
};

export default HotelService;
